<template>
    <div class="epidemic">
        <div class="epidemic-top" span="24">
            <div class="epidemic-publicity-img">
                <img src="../assets/epidemic-big.png" style="width: 100%">
            </div>
            <div class="epidemic-information">
                <div class="information-title">
                    <img src="../assets/title-icon.png" class="title-icon">
                    <span>
                        全法新冠状肺炎实时动态
                    </span>
                </div>
                <div class="information-time">
                    更新时间：{{totalCount.date}}
                </div>
                <div class="epidemic-detail-info">
                    <van-row>
                        <van-col span="8">
                            <div class="detail-info-title">累计确诊</div>
                            <div class="detail-info-number c1">{{totalCount.confirmedNumber}}</div>
                            <div class="detail-info-add">
                                <span class="left">较昨日</span>
                                <span class="right c1">+{{totalCount.confirmedIncrease}}</span>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="detail-info-title">累计治愈</div>
                            <div class="detail-info-number c2">{{totalCount.recoveredNumber}}</div>
                            <div class="detail-info-add">
                                <span class="left">较昨日</span>
                                <span class="right c2">+{{totalCount.recoveredIncrease}}</span>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="detail-info-title">累计死亡</div>
                            <div class="detail-info-number c3">{{totalCount.deathNumber}}</div>
                            <div class="detail-info-add">
                                <span class="left">较昨日</span>
                                <span class="right c3">+{{totalCount.deathIncrease}}</span>
                            </div>
                        </van-col>
                    </van-row>
                    <van-row  style="padding-top: 15px">
                        <van-col span="8" offset="4">
                            <div class="detail-info-title">现有确诊</div>
                            <div class="detail-info-number c4">{{totalCount.activeNumber}}</div>
                            <div class="detail-info-add">
                                <span class="left">较昨日</span>
                                <span class="right c4">+{{totalCount.activeIncrease}}</span>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="detail-info-title">现有重诊</div>
                            <div class="detail-info-number c5">{{totalCount.criticalNumber}}</div>
                            <div class="detail-info-add">
                                <span class="left">较昨日</span>
                                <span class="right c5">+{{totalCount.criticalIncrease}}</span>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>
        <div class="epidemic-tendency-chart">
            <div class="tendency-chart">
                <div class="chart-title">
                    <img src="../assets/title-icon.png" class="title-icon">
                    <span v-if="active == 1">
                        法国疫情现有确诊趋势图
                    </span>
                    <span v-if="active == 2">
                        法国疫情新增确诊趋势图
                    </span>
                    <span v-if="active == 3">
                        法国疫情累计确诊趋势图
                    </span>
                </div>
                <div class="chart-tag">
                    <div class="chart-tag-dody">
                        <div :class="[active==1?'chart-tag-text active':'chart-tag-text']">
                            <template>
                                <div class="vol-data">
                                    <div class="charts" style="width:100%;">
                                        <div class="charts-title">
                                            <span class="charts-title-color c1"></span>现有确诊
                                        </div>
                                        <div id="myChart" :style="{width:'100%',height:'280px'}">
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div :class="[active==2?'chart-tag-text active':'chart-tag-text']">
                            <template>
                                <div class="vol-data">
                                    <div class="charts" style="width:100%;">
                                        <div class="charts-title">
                                            <span class="charts-title-color c2"></span>新增确诊
                                        </div>
                                        <div id="myChart2" :style="{width:'100%',height:'280px'}">
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div :class="[active==3?'chart-tag-text active':'chart-tag-text']">
                            <template>
                                <div class="vol-data">
                                    <div class="charts" style="width:100%;">
                                        <div class="charts-title">
                                            <span class="charts-title-color c3"></span><span class="chart-title-name">累计确诊</span>
                                            <span class="charts-title-color c4"></span><span class="chart-title-name">累计治愈</span>
                                            <span class="charts-title-color c5"></span><span class="chart-title-name">累计死亡</span>
                                        </div>
                                        <div id="myChart3" :style="{width:'100%',height:'280px'}">
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="tab-left-button" @click="goLeftTab"><img src="../assets/tab-left-bu.png"></div>
                        <div class="tab-right-button" @click="goRightTab"><img src="../assets/tab-right-bu.png"></div>
                    </div>
                    <div class="chart-tag-name">
                        <div :class="[active==1?'chart-tag-list left active':'chart-tag-list left']" @click="onShow(1)">
                            现有确诊
                        </div>
                        <div :class="[active==2?'chart-tag-list active':'chart-tag-list']" @click="onShow(2)">
                            新增确诊
                        </div>
                        <div :class="active==3?'chart-tag-list right active':'chart-tag-list right'" @click="onShow(3)">
                            累计确诊
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="epidemic-body">
            <div class="company-events">
                <div class="information-title">
                    <img src="../assets/title-icon.png" class="title-icon">
                    <span>
                        疫情动态
                    </span>
                </div>
                <div class="company-events-body">
                    <div class="company-events-list"  v-for="(item,index) in newsOne" :key="index">
                        <div class="events-list icon">
                            <div :class="[index==0?'top':'']"></div>
                        </div>
                        <div class="events-list text">
                            <div :class="[(index == newsOne.length-1 && newsTwo.length == 0)?'':'events-list-left-line']"></div>
                            <router-link :to="item.url" target="_blank">
                                <div class="new-title">{{item.title}}</div>
                            </router-link>
                            <div class="new-date">{{item.date}}</div>
                        </div>
                    </div>
                    <template v-if="newsTwo.length !== 0">
                        <div :class="[isShow?'company-events-list hide':'company-events-list']">
<!--                        <div class="company-events-list">-->
                            <div class="events-list icon">
                                <img src="../assets/more-news.png" class="more-news-icon" @click="showMore">
                            </div>
                            <div class="events-list text">
                                <div class="events-list-left-line"></div>
                                <div class="more-news-brace"></div>
                            </div>
                        </div>
                        <div :class="[isShow?'company-events-list':'company-events-list hide']"  v-for="(item,index) in newsTwo" :key="'two'+index">
                            <div class="events-list icon">
                                <div></div>
                            </div>
                            <div class="events-list text">
                                <div class="events-list-left-line"></div>
                                <router-link :to="item.url" target="_blank">
                                    <div class="new-title">{{item.title}}</div>
                                </router-link>
                                <div class="new-date">{{item.date}}</div>
                            </div>
                        </div>
                    </template>
                    <template v-if="newsThree">
                        <div class="company-events-list"  v-for="(item,index) in newsThree" :key="'three'+index">
                            <div class="events-list icon">
                                <div></div>
                            </div>
                            <div class="events-list text">
                                <router-link :to="item.url" target="_blank">
                                    <div class="new-title">{{item.title}}</div>
                                </router-link>
                                <div class="new-date">{{item.date}}</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="epidemic-base">
            <div class="information-title">
                <img src="../assets/title-icon.png" class="title-icon">
                <span>
                     实时辟谣
                </span>
            </div>
            <div class="rumor">
                <div class="rumor-list" v-for="(item,index) in rumor" :key="index">
                    <a :href="item.url">
                        <span class="title">{{item.title}}</span>
                        <van-tag type="danger" color="rgb(194,14,14)">谣言</van-tag>
                    </a>
                </div>
            </div>
            <a href="https://www.ecentime.com/search/info/辟谣跑断腿" target="_blank">
                <div class="rumor-more">
                    <span>查看完整版辟谣专区</span>
                    <img src="../assets/link-to.png">
                </div>
            </a>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import echarts from 'echarts'
    import { Tag } from 'vant';
    Vue.use(Tag);
    Vue.use(echarts);
    export default {
        data() {
            return {
                newsOne:[],
                newsTwo:[],
                newsThree:[],
                isShow:false,
                active:1,
                news:[],
                rumor:[],
                companyEvents:[],
                definiteNow:[],
                definiteAdd:[],
                definiteTotal:[],
                totalCount:[]
            }
        },
        beforeCreate(){
            //获取疫情统计数据
            this.$axios.get('/api/service/covid/newData').then(res => {
                if(res.data.code == 0){
                    // console.log(res.data.data);
                    this.totalCount = res.data.data;
                }
            }).catch(error => {
                console.log(error);
                // this.$router.push("/error")
            });
            //获取疫情新闻数据
            this.$axios.get('/api/service/covid/getNews/1').then(res => {
                if(res.data.code == 0){
                    this.companyEvents = res.data.data;
                    this.newsOne = [];
                    this.newsTwo = [];
                    this.newsThree = [];
                    if(this.companyEvents.length > 5){
                        for (var i=0;i<this.companyEvents.length;i++){
                            if(i>2 && i< (this.companyEvents.length-1)){
                                this.newsTwo.push(this.companyEvents[i]);
                            }else if(i==(this.companyEvents.length-1)){
                                this.newsThree.push(this.companyEvents[i])
                            }else {
                                this.newsOne.push(this.companyEvents[i])
                            }
                        }
                    }else {
                        this.newsOne = this.companyEvents;
                    }
                    // console.log(this.newsOne);
                    // console.log(this.newsTwo);
                    // console.log(this.newsThree);
                }
            }).catch(error => {
                console.log(error);
                // this.$router.push("/error")
            });
        //获取谣言数据
            this.$axios.get('/api/service/covid/getNews/2').then(res => {
                if(res.data.code == 0){
                    this.rumor = res.data.data;
                }
            }).catch(error => {
                console.log(error);
                // this.$router.push("/error")
            });
        //获取图表数据
            this.$axios.get('/api/service/covid/view').then(res => {
                if(res.data.code == 0){
                    var epidemicData = res.data.data;
                    var definiteNowDate = [];
                    var definiteNowValue = [];
                    var definiteAddDate = [];
                    var definiteAddValue = [];
                    var definiteTotalDate = [];
                    var definiteTotalValue0 = [];
                    var definiteTotalValue1 = [];
                    var definiteTotalValue2 = [];
                    for(var i = 0; i < epidemicData.length; i ++){
                        //现有确诊
                        var item = {
                            'value':epidemicData[i]['activeNumber'],
                            'date':epidemicData[i]['shortDate']
                        };
                        //新增确诊
                        var item2 = {
                            'value':epidemicData[i]['confirmedIncrease'],
                            'date':epidemicData[i]['shortDate']
                        };
                        //累计确诊
                        var item3 = {
                            'value':epidemicData[i]['confirmedNumber'],
                            'date':epidemicData[i]['shortDate']
                        };
                        //累计治愈
                        var item4 = {
                            'value':epidemicData[i]['recoveredNumber'],
                            'date':epidemicData[i]['shortDate']
                        };
                        //累计死亡
                        var item5 = {
                            'value':epidemicData[i]['deathNumber'],
                            'date':epidemicData[i]['shortDate']
                        };
                        definiteNowDate.push(epidemicData[i]['littleDate']);
                        definiteAddDate.push(epidemicData[i]['littleDate']);
                        definiteTotalDate.push(epidemicData[i]['littleDate']);
                        definiteNowValue.push(item);
                        definiteAddValue.push(item2);
                        definiteTotalValue0.push(item3);
                        definiteTotalValue1.push(item4);
                        definiteTotalValue2.push(item5);

                    }
                    this.definiteNow['date'] = definiteNowDate;
                    this.definiteNow['value'] = definiteNowValue;
                    this.definiteAdd['date'] = definiteAddDate;
                    this.definiteAdd['value'] = definiteAddValue;
                    this.definiteTotal['date'] = definiteTotalDate;
                    this.definiteTotal['value'] = [definiteTotalValue0,definiteTotalValue1,definiteTotalValue2];
                    this.onShow(1);
                }
            }).catch(error => {
                console.log(error);
                // this.$router.push("/error")
            });
        },
        methods: {
            showMore() {
                if(this.isShow){
                    this.isShow = false
                }else {
                    this.isShow = true
                }
            },
            goLeftTab(){
                var newActive = (this.active - 1)%4;
                if(newActive == 0){
                    newActive = 3
                }
                this.active = newActive;
                this.onShow(newActive)
            },
            goRightTab(){
                var newActive = (this.active + 1)%4;
                if(newActive == 0){
                    newActive = 1
                }
                this.active = newActive;
                this.onShow(newActive)
            },
            onShow(n){
                this.active = n;
                var tab = document.getElementsByClassName('chart-tag-text');
                var myChart = echarts.init(document.getElementById('myChart'));
                var myChart2 = echarts.init(document.getElementById('myChart2'));
                var myChart3 = echarts.init(document.getElementById('myChart3'));
                var option = {
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel:{
                            rotate:45,
                            margin:12,
                            color:'#9b9b9b',
                            fontStyle:'normal',
                            fontFamily:'Microsoft YaHei',
                            fontSize:8,
                        },
                        data: this.definiteNow['date']
                    },
                    yAxis: {
                        type: 'value',
                        axisLine:{
                            show:false
                        },
                        axisTick:{
                            show: false
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        triggerOn:'mousemove|click',
                        formatter:function(data)
                        {
                            // console.log(data);
                            return data[0].data.date + '<br/>' +data[0].seriesName + '：'+data[0].value; //将小数转化为百分数显示
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        x: 50,
                        y: 25,
                        x2: 30,
                        y2: 35,
                        containLabel: true
                    },
                    series: [{
                        smooth:true,
                        name:'现有确诊',
                        data: this.definiteNow['value'],
                        type: 'line',
                        color: '#ed5f00'
                    }]
                };
                var option2 = {
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel:{
                            rotate:45,
                            margin:12,
                            color:'#9b9b9b',
                            fontStyle:'normal',
                            fontFamily:'Microsoft YaHei',
                            fontSize:8,
                        },
                        data: this.definiteAdd['date']
                    },
                    yAxis: {
                        type: 'value',
                        axisLine:{
                            show:false
                        },
                        axisTick:{
                            show: false
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        triggerOn:'mousemove|click',
                        formatter:function(data)
                        {
                            // console.log(data);
                            return data[0].data.date + '<br/>' +data[0].seriesName + '：'+data[0].value; //将小数转化为百分数显示
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        x: 50,
                        y: 25,
                        x2: 30,
                        y2: 35,
                        containLabel: true
                    },
                    series: [{
                        smooth:true,
                        name:'新增确诊',
                        data: this.definiteAdd['value'],
                        type: 'line',
                        color: '#db2145'
                    }]
                };
                var option3 = {
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel:{
                            rotate:45,
                            margin:12,
                            color:'#9b9b9b',
                            fontStyle:'normal',
                            fontFamily:'Microsoft YaHei',
                            fontSize:8,
                        },
                        data: this.definiteTotal['date']
                    },
                    yAxis: {
                        type: 'value',
                        axisLine:{
                            show:false
                        },
                        axisTick:{
                            show: false
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        triggerOn:'mousemove|click',
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        x: 50,
                        y: 25,
                        x2: 30,
                        y2: 35,
                        containLabel: true
                    },
                    series: [
                        {
                            smooth: true,
                            name: '累计确诊',
                            data: this.definiteTotal['value'][0],
                            type: 'line',
                            color: '#c30101'
                        },
                        {
                            smooth:true,
                            name:'累计治愈',
                            data: this.definiteTotal['value'][1],
                            type: 'line',
                            color: '#4ad863'
                        },
                        {
                            smooth:true,
                            name:'累计死亡',
                            data: this.definiteTotal['value'][2],
                            type: 'line',
                            color: '#3c3c3c'
                        },
                    ]
                };
                if(n == 1){
                    tab[0].style.cssText = "display:block";
                    tab[1].style.cssText = "display:none";
                    tab[2].style.cssText = "display:none";
                    myChart.resize();
                    myChart.setOption(option);
                    return;
                }
                if(n == 2){
                    tab[0].style.cssText = "display:none";
                    tab[1].style.cssText = "display:block";
                    tab[2].style.cssText = "display:none";
                    myChart2.resize();
                    myChart2.setOption(option2);
                    return;
                }
                if(n == 3){
                    tab[0].style.cssText = "display:none";
                    tab[1].style.cssText = "display:none";
                    tab[2].style.cssText = "display:block";
                    myChart3.resize();
                    myChart3.setOption(option3);
                    return;
                }
            },
        },
        mounted(){

        }
    }
</script>
<style scoped>
    .epidemic::before{
        content:" ";
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        background-color:#f3f3f3;/* 颜色自定义 */
        z-index:-100;/* 突然想到个游戏，是男人就下100层。。。 */
    }
    .epidemic-top{
        background-color: #fff;
    }
    .epidemic-publicity-img{
        font-size: 0;padding: 16px 15px 0;
    }
    .epidemic-information{
        padding: 20px;
    }
    .information-title{
        font-size: 15px; color: #4a4a4a;font-weight: 600;height: 21px;line-height: 21px;position: relative;
    }
    .information-title span{padding-left: 2px}
    .information-time{padding-left: 2px}
    .information-time,.events-list .new-date{
        font-size:12px;color:rgba(155,155,155,0.48);margin-top: 3px;
    }
    .epidemic-detail-info{
        padding-top: 15px;text-align: center;
    }
    .detail-info-title{
        width: 105px;color:#4a4a4a ;font-size: 12px;background-color: #f7f7f7;height: 20px;line-height: 20px;border-radius: 6px;
    }
    .detail-info-number{
        font-size: 18px;font-weight: 600;height: 25px;line-height: 25px;padding-top: 7px;
    }
    .detail-info-add{font-size: 12px;color: #9b9b9b;padding-top: 3px}
    .detail-info-number.c1,.detail-info-add .right.c1{color: #c30000}
    .detail-info-number.c2,.detail-info-add .right.c2{color: #4bda64}
    .detail-info-number.c3,.detail-info-add .right.c3{color: #3c3c3c}
    .detail-info-number.c4,.detail-info-add .right.c4{color: #ed5f00;}
    .detail-info-number.c5,.detail-info-add .right.c5{color: #013edd;}
    .detail-info-title{margin: 0 auto}
    .epidemic-body{padding: 17px 0px 8px;background-color: #fff;margin-top: 7px;position: relative;overflow: hidden}
    .company-events-list .events-list{float: left}
    .company-events .information-title{padding-bottom: 15px;margin-left: 20px}
    .company-events-list{overflow: hidden;position: relative;margin: 0 17px}
    .events-list.icon{position: relative;top: 6px;width: 20px}
    .events-list.icon div{width: 6px;height: 6px;border-radius: 3px;background-color: rgb(176,175,175);margin: 0 auto}
    .events-list.icon .top{background-color: rgb(3,3,3)}
    .events-list.text{width: 90%;padding-bottom: 12px}
    .events-list .new-title{font-size: 14px;color: #4a4a4a;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
    .events-list-left-line{
        border-left:1px solid #b0afaf;width: 1px;height: 100%;position: absolute;top: 18px;left: 9px;
    }
    .epidemic-base{
        padding: 17px 22px 0;background-color: #fff;margin-top: 7px;
    }
    .epidemic-base::before{
        content:" ";
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        background-color:#fff;/* 颜色自定义 */
        z-index:-100;/* 突然想到个游戏，是男人就下100层。。。 */
    }
    .rumor-more{
        padding-bottom: 14px;text-align: center;font-size: 12px;color: #4a4a4a;
    }
    .rumor-more img{
        width: 15px;position: relative;top: 3px;margin-left: 10px;
    }
    .rumor-list{
        font-size: 14px;color: #4a4a4a;padding-bottom: 14px;border-bottom: 1px solid rgb(245,245,245);margin-bottom: 14px;
    }
    .epidemic-base .information-title{
        margin-bottom: 15px;
    }
    .rumor-list .title{width: 85%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color: #4a4a4a}
    .rumor-list span{
        display: inline-block;
    }
    .rumor-list .van-tag{float: right}
    .title-icon{
        width: 4px;height: 14px;position: absolute;left: -7px;top: 3px;
    }
    .more-news-icon{width: 69px;height: 18px;position: relative;top: -6px;left: 1px}
    .company-events-list.more{margin: 0;height: 48px}
    .company-events-list.hide{display: none}
    .more-news-brace{height: 36px}
    .more-news-icon:hover{cursor: pointer}
    .epidemic-tendency-chart{
        padding: 17px 0 20px;
        background-color: #fff;
        margin-top: 7px;
        position: relative;
        overflow: hidden;
        font-size: 15px;
        color: #4a4a4a;
        font-weight: 600;
    }
    .chart-tag-name{padding: 0 30px;text-align: center}
    .epidemic-tendency-chart .chart-title{padding-bottom: 15px; margin-left: 20px;position: relative;}
    .epidemic-tendency-chart .chart-title span{padding-left: 2px;}
    .chart-tag-name div{
        padding: 5px 25px;font-size: 12px;background-color: #f3f3f3;display: inline-block;color: #4a4a4a;cursor: pointer;border-radius: 6px;font-weight: 500;
    }
    .chart-tag-name div.left{float: left}
    .chart-tag-name div.right{float: right}
    .chart-tag-list.active{background-color: #ffed9b;color: #ff733a}
    .chart-tag-text{display: none;padding: 0 22px;font-weight: 500}
    .chart-tag-text.active{display: block;}
    .charts-title{color: #4a4a4a;font-size: 12px;padding: 0 10px;}
    .charts-title-color{width: 12px;height: 12px;display: inline-block;position: relative;margin-right: 5px;top: 2px}
    .charts-title-color.c1{background-color: #ed5f00;}
    .charts-title-color.c2{background-color: #db2145;}
    .charts-title-color.c3{background-color: #c30101;}
    .charts-title-color.c4{background-color: #4ad863;}
    .charts-title-color.c5{background-color: #3c3c3c;}
    .chart-title-name{margin-right: 10px}
    .tab-left-button,.tab-right-button{width: 23px;height: 32px;position: absolute;top: 42%;cursor: pointer}
    .tab-right-button{right: 0}
    .tab-left-button img,.tab-right-button img{width: 23px}
</style>
